import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useApi } from "@/shared/api";
import { HeadContact } from "../model";

export const useHeadContact = () => {
  const { api } = useApi({ version: "v2" });
  return useQuery({
    queryKey: ["headContact"],
    queryFn: async () => {
      return await api.get<{ data: HeadContact }>("/head-contacts");
    },
  });
};

export const useUpsertHeadContact = () => {
  const { api } = useApi({ version: "v2" });
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["upsertHeadContact"],
    mutationFn: async (data: { contact: string }) => {
      return await api.patch<{ data: HeadContact }>(
        "/head-contacts/upsert",
        data,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["headContact"] });
    },
  });
};
